<p-paginator
  [showFirstLastIcon]="false"
  [first]="currentPage()"
  [rows]="pageSize()"
  [totalRecords]="totalCount()"
  [templateRight]="templateRight"
  (onPageChange)="onPageChange($event)"
  styleClass="swd-paginator">
  <ng-template
    #templateRight
    let-state>
    {{ currentRange() }}
  </ng-template>
  <ng-template #previouspagelinkicon>
    <span>
      {{ 'paginator.previous' | translate }}
      <i class="pi pi-angle-left">&nbsp;</i>
    </span>
  </ng-template>
  <ng-template #nextpagelinkicon>
    <span>
      {{ 'paginator.next' | translate }}
      <i class="pi pi-angle-right">&nbsp;</i>
    </span>
  </ng-template>
</p-paginator>
